import axios from 'axios';

const API_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3001';

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  if (typeof window !== 'undefined') {
    const token = localStorage.getItem('amam_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

// Auth API
export const authApi = {
  login: (email: string, password: string) =>
    api.post('/auth/login', { email, password }),
  register: (data: { email: string; password: string; name: string; phone?: string; source?: string }) =>
    api.post('/auth/register', data),
  getProfile: () => api.get('/auth/profile'),
  updateProfile: (data: { name?: string; phone?: string; address?: { street: string; city: string; postalCode?: string } }) =>
    api.put('/auth/profile', data),
  verifyEmail: (token: string) => api.get(`/auth/verify-email?token=${token}`),
  forgotPassword: (email: string) =>
    api.post('/auth/forgot-password', { email }),
  resetPassword: (token: string, newPassword: string) =>
    api.post('/auth/reset-password', { token, newPassword }),
  // Address management
  addAddress: (address: { name: string; street: string; city: string; phone?: string; notes?: string; isDefault?: boolean }) =>
    api.post('/auth/addresses', address),
  updateAddress: (index: number, address: { name?: string; street?: string; city?: string; phone?: string; notes?: string; isDefault?: boolean }) =>
    api.put(`/auth/addresses/${index}`, address),
  deleteAddress: (index: number) =>
    api.delete(`/auth/addresses/${index}`),
};

// Products API
export const productsApi = {
  getMenu: () => api.get('/products/menu'),
  getProducts: (categoryId?: string) =>
    api.get('/products', { params: { category: categoryId } }),
  getProduct: (id: string) => api.get(`/products/${id}`),
  getCategories: () => api.get('/categories'),
};

// Orders API
export const ordersApi = {
  createOrder: (data: any) => api.post('/orders', data),
  createGuestOrder: (data: any) => api.post('/orders/guest', data),
  getMyOrders: () => api.get('/orders/my-orders'),
  getOrder: (id: string) => api.get(`/orders/${id}`),
  getOrderByNumber: (orderNumber: string) =>
    api.get(`/orders/number/${orderNumber}`),
};

// Order Options API
export const orderOptionsApi = {
  getOrderOptions: () => api.get('/order-options'),
};

// Favorites API
export const favoritesApi = {
  getFavorites: () => api.get('/favorites'),
  createFavorite: (data: any) => api.post('/favorites', data),
  updateFavorite: (id: string, data: any) => api.patch(`/favorites/${id}`, data),
  deleteFavorite: (id: string) => api.delete(`/favorites/${id}`),
};

// Pages API
export const pagesApi = {
  getPages: () => api.get('/pages'),
  getPageBySlug: (slug: string) => api.get(`/pages/slug/${slug}`),
  getPagesByCategory: (category: string) => api.get(`/pages/category/${category}`),
};

// Settings API
export const settingsApi = {
  getSettings: () => api.get('/settings'),
};
